<div class="typo-s1 text-table-text-line truncate">{{ content.headline }}</div>
<div class="typo-body-xs text-table-text-line-gray truncate">{{ content.subline }}</div>
